import { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  RESTAURANT_USER_ROLE,
  useAuthUserRestaurant,
  useGetMenuTypesQuery,
} from '@durma-soft/gros-sdk';

import { Link } from '@/components/shared/link';
import { DataTable } from '@/components/shared/data-table';
import { buttonVariants } from '@/components/shared/shadcn-ui/button';
import { EditRestaurantMenuTypeModal } from '@/components/restaurant/menu-types/edit-restaurant-menu-type-modal';
import { CreateRestaurantMenuTypeModal } from '@/components/restaurant/menu-types/create-restaurant-menu-type-modal';

import { columns } from '@/config/restaurant/menu-types';

const RestaurantMenuTypes = () => {
  const { t } = useTranslation();
  const { menuTypeId } = useParams();
  const memoizedColumns = useMemo(() => {
    return columns(t);
  }, [t]);

  const restaurant = useAuthUserRestaurant();
  const hasEditPermission = restaurant.role !== RESTAURANT_USER_ROLE.EMPLOYEE;

  const { data, isLoading } = useGetMenuTypesQuery(restaurant.id);

  return (
    <>
      <Helmet>
        <title>{t('menu-type.title')}</title>
      </Helmet>
      <div>
        <div className="flex items-center">
          <h1 className="text-lg font-semibold md:text-2xl">
            {t('menu-type.title')}
          </h1>
        </div>
        <div className="flex flex-col gap-3">
          <div className="self-end">
            <Link
              to="/restaurant/menu-types/create"
              className={buttonVariants({ variant: 'default' })}
            >
              {t('menu-type.create')}
            </Link>
          </div>
          <DataTable
            columns={memoizedColumns}
            data={data}
            isLoading={isLoading}
            columnVisibility={{
              edit: hasEditPermission,
            }}
          />
        </div>
      </div>
      <CreateRestaurantMenuTypeModal />
      {Boolean(menuTypeId) && <EditRestaurantMenuTypeModal key={menuTypeId} />}
    </>
  );
};

export default RestaurantMenuTypes;
